import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../../shared/auth/auth';
import { Persona, PersonaSize, PersonaPresence } from '@fluentui/react';
import { ContextualMenu, IContextualMenuItem } from '@fluentui/react';
import { DirectionalHint } from '@fluentui/react';
import { GraphApi } from '../../../shared/api/api';

const ProfileInfo: React.FC = () => {
    const navigate = useNavigate();
    const [photoUrl, setPhotoUrl] = useState('');
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const personaRef = useRef<HTMLDivElement>(null);
    const abortControllerRef = useRef<AbortController | null>(null);

    const toggleMenu = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsMenuVisible((prev) => !prev);
    };

    const dismissMenu = (ev?: any) => {
        if (ev && ev.type === 'click' && personaRef.current && personaRef.current.contains(ev.target as Node)) {
            return;
        }
        setIsMenuVisible(false);
    };

    const dismissMenuImmediately = () => {
        setIsMenuVisible(false);
    };

    useEffect(() => {
        const controller = new AbortController();
        abortControllerRef.current = controller;

        const loadUserProfilePhoto = async () => {
            const photoResponse = await GraphApi.getUserPhoto(controller.signal);
            if (photoResponse.success) {
                const url = window.URL || (window as any).webkitURL;
                const fetchedPhotoUrl = url.createObjectURL(photoResponse.result);
                setPhotoUrl(fetchedPhotoUrl);
            }
        };

        loadUserProfilePhoto();

        return () => {
            controller.abort();
        };
    }, []);

    const userProfile = auth.getUserProfile();
    const displayName = userProfile ? userProfile.displayName : '';

    const menuItems: IContextualMenuItem[] = [
        {
            key: 'refreshToken',
            text: 'Refresh token',
            iconProps: { iconName: 'Refresh' },
            onClick: () => {
                dismissMenuImmediately();
                auth.login();
            },
        },
        {
            key: 'userDetails',
            text: 'User Details',
            iconProps: { iconName: 'Contact' },
            onClick: () => {
                dismissMenuImmediately();
                navigate('/userdetails');
            },
        },
    ];

    return (
        <div ref={personaRef} className="ProfileInfo" onClick={toggleMenu}>
            <Persona imageUrl={photoUrl} size={PersonaSize.size28} presence={PersonaPresence.online} hidePersonaDetails={false} text={displayName} />
            {isMenuVisible && (
                <ContextualMenu
                    items={menuItems}
                    target={personaRef.current}
                    onDismiss={dismissMenu}
                    directionalHint={DirectionalHint.bottomRightEdge}
                    gapSpace={0}
                />
            )}
        </div>
    );
};

export default ProfileInfo;
